import Email from "../email";
import Logo from "./logo";
import NavLinks from "./nav-links";
import PropTypes from "prop-types";
import React from "react";
import Social from "../social/social";
import TeamPhone from "../../shared/team-phone";
import Phones from "../../contact/phones";
import { validate2AgentTeam } from "../../shared/util";

const MobileMenu = ({ entity, items, toggleMenu }) => {
  let socials = null;
  if (entity.socials.length > 0) {
    socials = (
      <div>
        <div className="social-divider"></div>
        <p>Follow</p>
        <Social socials={entity.socials} />
      </div>
    );
  }
  return (
    <div className="mobile-body">
      <div className="gold-divider"></div>
      <div className="container">
        <div className="row">
          <div className="small-nav-links col-xs-8 col-xxs-16">
            <NavLinks items={items} toggleMenu={toggleMenu} />
          </div>
          <div className="contact col-xs-8 col-xxs-16">
            {/* <div><Phone prefix="Tel" number={entity.primaryPhone}/></div> */}
            <div>
              {entity && validate2AgentTeam(entity) ? (
                <TeamPhone
                  classes="line-item tel"
                  entity={entity}
                  prefix="Tel"
                  separator={false}
                />
              ) : (
                <Phones entity={entity} />
              )}
            </div>
            <div>
              <Email email={entity.emailAddress} />
            </div>
            {socials}
            <div className="social-divider"></div>
            <Logo entity={entity} toggleMenu={toggleMenu} />
          </div>
        </div>
      </div>
    </div>
  );
};

MobileMenu.propTypes = {
  items: PropTypes.array.isRequired,
  toggleMenu: PropTypes.func.isRequired,
};

export default MobileMenu;



// WEBPACK FOOTER //
// ./src/components/shared/navbar/mobile-menu.js